import * as React from 'react';
import { CheckoutOrderFragment } from '@websky/graphql';

interface RefundContextProps {
	updateOrder: () => Promise<CheckoutOrderFragment>;
}

const RefundContext = React.createContext<RefundContextProps>(null!);

export function useRefund() {
	return React.useContext(RefundContext);
}

const RefundProvider: React.FC<RefundContextProps> = ({ children, ...props }) => {
	return <RefundContext.Provider value={props}>{children}</RefundContext.Provider>;
};

export default RefundProvider;
